import { setIn } from 'final-form';
import { useMemo } from 'react';
import { ObjectSchema, ValidationError } from 'yup';
import { ObjectShape } from 'yup/lib/object';

const useValidationSchema = (schema: ObjectSchema<ObjectShape>) => {
  return useMemo(() => makeValidate(schema), [schema]);
};

const makeValidate = (schema: ObjectSchema<ObjectShape>) => {
  return async (values: object) => {
    try {
      await schema.validate(values, { abortEarly: false });
    } catch (error: unknown) {
      return (error as ValidationError).inner.reduce(setInError, {});
    }
  };
};

const setInError = (errors: object, innerError: ValidationError) => {
  return setIn(errors, innerError.path || '', innerError.message);
};

export default useValidationSchema;
